import React from 'react';

const SVG = ({ shape, color, width, viewBox = '0 0 100 100' }) => {
  const style = {
    fill: '#0006',
    stroke: '#0006',
    transform: 'translate(4px,4px)',
  };
  return (
    <svg width={width || '35px'} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
      <g stroke="white" strokeWidth="3" fill={color} transform="translate(0,-1)">
        {shape === 'square' ? (
          <g>
            <rect style={style} x="18" y="18" width="64" height="64" />
            <rect x="18" y="18" width="64" height="64" />
          </g>
        ) : shape === 'club' ? (
          <g>
            <path
              style={{ ...style, transform: 'translate(9px, 9px)' }}
              d="M30 33C25.8438 31.6481 21.4688 29.661 17 30.2276C-9.40963 33.5764 2.93645 77.8933 30 66.7762C37.0611 63.8757 39.8759 57.9639 45 53C44.1911 63.2351 40.9779 74.0843 31.9961 80.1466C27.2012 83.383 19.1322 83.1123 16 88L75 88C72.0156 83.3436 64.6251 83.797 60 80.8665C50.202 74.6585 46.2306 64.1703 46 53L47 53C48.9234 57.0422 51.3419 60.6745 55.0147 63.3619C57.9299 65.495 61.4814 66.9746 65 67.7461C91.4082 73.5365 96.7116 30.0819 71 30.0802C67.0811 30.08 63.5877 31.6184 60 33C62.0442 29.4803 63.7387 26.142 63.956 22C65.3749 -5.04271 22.9844 -3.69376 26.186 23C26.6255 26.6646 28.2037 29.8399 30 33z"
            />
            <path
              transform="translate(5,5)"
              d="M30 33C25.8438 31.6481 21.4688 29.661 17 30.2276C-9.40963 33.5764 2.93645 77.8933 30 66.7762C37.0611 63.8757 39.8759 57.9639 45 53C44.1911 63.2351 40.9779 74.0843 31.9961 80.1466C27.2012 83.383 19.1322 83.1123 16 88L75 88C72.0156 83.3436 64.6251 83.797 60 80.8665C50.202 74.6585 46.2306 64.1703 46 53L47 53C48.9234 57.0422 51.3419 60.6745 55.0147 63.3619C57.9299 65.495 61.4814 66.9746 65 67.7461C91.4082 73.5365 96.7116 30.0819 71 30.0802C67.0811 30.08 63.5877 31.6184 60 33C62.0442 29.4803 63.7387 26.142 63.956 22C65.3749 -5.04271 22.9844 -3.69376 26.186 23C26.6255 26.6646 28.2037 29.8399 30 33z"
            />
          </g>
        ) : shape === 'triangle' ? (
          <g>
            <path style={style} d="M50,15 10,85 90,85 Z" />
            <path d="M50,15 10,85 90,85 Z" />
          </g>
        ) : shape === 'circle' ? (
          <g>
            <circle style={style} cx="50" cy="50" r="36" />
            <circle cx="50" cy="50" r="36" />
          </g>
        ) : shape === 'rhombus' ? (
          <g>
            <path style={style} d="M50,5 5,50, 50,95 95,50 z" />
            <path d="M50,5 5,50, 50,95 95,50 z" />
          </g>
        ) : shape === 'heart' ? (
          <g>
            <path style={style} d="M 10,30 A 20,20 0,0,1 50,30 A 20,20 0,0,1 90,30 Q 90,60 50,90 Q 10,60 10,30" />
            <path d="M 10,30 A 20,20 0,0,1 50,30 A 20,20 0,0,1 90,30 Q 90,60 50,90 Q 10,60 10,30" />
          </g>
        ) : shape === 'star' ? (
          <g>
            <polygon style={style} points="50,7.6 60.5,40 93.8,40 67,59.7 77.9,92.3 50,72.3 22.1,92.3 33,59.7 6.2,40 39.5,40" />
            <polygon points="50,7.6 60.5,40 93.8,40 67,59.7 77.9,92.3 50,72.3 22.1,92.3 33,59.7 6.2,40 39.5,40" />
          </g>
        ) : shape === 'crescent' ? (
          <g>
            <path style={{ ...style, transform: 'translate(1px, 4px)' }} d="M20,10 C 110,0 110,100 20,90 C 70,80 70,20 20,10" />
            <path transform="translate(-3,0)" d="M20,10 C 110,0 110,100 20,90 C 70,80 70,20 20,10" />
          </g>
        ) : shape === 'cross' ? (
          <g>
            <path style={style} d="M9.5,36.5 h27 v-27 h27 v27 h27 v27 h-27 v27 h-27 v-27 h-27 z" />
            <path d="M9.5,36.5 h27 v-27 h27 v27 h27 v27 h-27 v27 h-27 v-27 h-27 z" />
          </g>
        ) : null}
      </g>
    </svg>
  );
};

export default SVG;
